import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/project_browse",
				name: "project_browse",
				component: () => import("../views/times/project_browse.vue"),
			},
			{
				path: "/version_current",
				name: "version_current",
				component: () => import("../views/times/version_current.vue"),
			},
			{
				path: "/version_all",
				name: "version_all",
				component: () => import("../views/times/version_all.vue"),
			},
			{
				path: "/req_wait",
				name: "req_wait",
				component: () => import("../views/times/req_wait.vue"),
			},
			{
				path: "/req_dev",
				name: "req_dev",
				component: () => import("../views/times/req_dev.vue"),
			},
			{
				path: "/req_test",
				name: "req_test",
				component: () => import("../views/times/req_test.vue"),
			},
			{
				path: "/req_accept",
				name: "req_accept",
				component: () => import("../views/times/req_accept.vue"),
			},
			{
				path: "/req_finish",
				name: "req_finish",
				component: () => import("../views/times/req_finish.vue"),
			},
			{
				path: "/req_submited",
				name: "req_submited",
				component: () => import("../views/times/req_submited.vue"),
			},
			{
				path: "/req_this",
				name: "req_this",
				component: () => import("../views/times/req_this.vue"),
			},
			{
				path: "/req_last",
				name: "req_last",
				component: () => import("../views/times/req_last.vue"),
			},
			{
				path: "/times_apply",
				name: "times_apply",
				component: () => import("../views/times/times_apply.vue"),
			},
			{
				path: "/times_exception",
				name: "times_exception",
				component: () => import("../views/times/times_exception.vue"),
			},
			{
				path: "/times_approve",
				name: "times_approve",
				component: () => import("../views/times/times_approve.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/times/config_right.vue"),
			},
			{
				path: "/config_flow",
				name: "config_flow",
				component: () => import("../views/times/config_flow.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/times/config_shortcut.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
